<template>
    <MapViewer
        class="o-terminal-map-controller terminal-map-controller"
        :map-data="getMvData"
        :active-view="activeView"
        :is-reactive="false"
        @ready="onMapReady"
    >
        <OMapGuideViews @changeView="setActiveView"></OMapGuideViews>
        <OMapExplorationViews @changeView="setActiveView"></OMapExplorationViews>
    </MapViewer>
</template>

<script>
import { mapGetters } from 'vuex';
import OMapGuideViews from "../o-map-guide-views/o-map-guide-views";
import MapViewer from "../../../shared/components/map-viewer/map-viewer";
import OMapExplorationViews from "../o-map-exploration-views/o-map-exploration-views";

export default {
    name: "ODMapController",
    components: {
        OMapExplorationViews,
        MapViewer,
        OMapGuideViews,
    },
    data() {
        return {
            activeView: 'OutdoorView',
        }
    },
    computed: {
        ...mapGetters([
            'getMvData'
        ]),
    },
    methods: {
        onMapReady() {
            this.$store.commit('setMapLoading', false);
        },
        setActiveView(activeView){
            this.activeView = activeView
        }
    },
}
</script>

<style lang="scss">
@import "d-map-controller";
</style>
